<div class="p-grid">
  <div class="p-col-12">
    <h4>Chemical Application Method Information</h4>
  </div>
</div>
<form id="methodForm" #methodForm="ngForm">
  <div class="p-grid">
    <div class="p-col-11">
      <h6>Method Name</h6>
      <input pInputText fluid #methodInput required name="name" [(ngModel)]="method.method"/>
    </div>
    <div class="p-col-1 push-contents-to-bottom">
      <p-button
        type="submit"
        (click)="saveChemicalApplicationMethod(methodForm)"
        [disabled]="saving"
        severity="success"  
        label="Save">
      </p-button>
      <p-button
        type="button"
        severity="warn"  
        (click)="clear(methodForm);"
        label="Clear">
      </p-button>
    </div>
  </div>
  <div class="ui-g-12 columnPadding">
    @if (methodForm.invalid && methodForm.submitted) {
      <div class="alert alert-danger" role="alert">
        There are errors on this page. Please correct the errors and resubmit.
      </div>
    }
  </div>
</form>
<br>
  <p-table showGridlines stripedRows responsiveLayout="stack" [columns]="cols" [value]="methods" [paginator]="true" [rows]="30">
    <ng-template pTemplate="header" let-columns>
      <tr>
        @for (col of columns; track col) {
          <th [pSortableColumn]="col.field" [style.width]="col.width">
            {{col.header}}
            @if (col.header != '') {
              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            }
          </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-method
      let-columns="columns"
      let-rowIndex="rowIndex">
      <tr>
        <td><span class="p-column-title">{{columns[0].header}}</span>{{method.method}}</td>
        <td>
          <p-button
            
            type="button"
            icon="pi pi-pencil"
            (click)="editChemicalApplicationMethod(method)"
            severity="info" >
          </p-button>
          <p-button
            
            type="button"
            icon="pi pi-trash"
            (click)="deleteChemicalApplicationMethod(method)"
            severity="danger">
          </p-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <br>
